import React, { useEffect, useState } from 'react';
type Purchase = {
  name: string;
  location: string;
  price: string;
  time: string;
};
export function SalesPopup() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState<Purchase | null>(null);
  const purchases: Purchase[] = [{
    name: 'William Perez',
    location: 'Massachusetts',
    price: '$19.97',
    time: 'Just now'
  }, {
    name: 'Sarah Johnson',
    location: 'Florida',
    price: '$39.97',
    time: 'Just now'
  }, {
    name: 'Michael Davis',
    location: 'Texas',
    price: '$94.97',
    time: 'Just now'
  }, {
    name: 'Emma Wilson',
    location: 'California',
    price: '$19.97',
    time: 'Just now'
  }, {
    name: 'Robert Brown',
    location: 'New York',
    price: '$39.97',
    time: 'Just now'
  }, {
    name: 'Jennifer Lee',
    location: 'Illinois',
    price: '$94.97',
    time: 'Just now'
  }, {
    name: 'David Miller',
    location: 'Ohio',
    price: '$19.97',
    time: 'Just now'
  }, {
    name: 'Lisa Garcia',
    location: 'Arizona',
    price: '$94.97',
    time: 'Just now'
  }, {
    name: 'James Wilson',
    location: 'Georgia',
    price: '$39.97',
    time: 'Just now'
  }, {
    name: 'Patricia Clark',
    location: 'Washington',
    price: '$19.97',
    time: 'Just now'
  }];
  useEffect(() => {
    // Initial delay before showing the first popup
    const initialTimeout = setTimeout(() => {
      showRandomPurchase();
    }, 3000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showRandomPurchase = () => {
    const randomIndex = Math.floor(Math.random() * purchases.length);
    setCurrentPurchase(purchases[randomIndex]);
    setVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setVisible(false);
      // Show next popup after hiding the current one
      setTimeout(() => {
        showRandomPurchase();
      }, 3000);
    }, 5000);
  };
  if (!visible || !currentPurchase) return null;
  return <div className="fixed inset-x-0 bottom-4 flex justify-center z-50 px-4" data-id="element-238">
      <div className="bg-white rounded-lg shadow-lg py-3 px-6 flex items-center w-full max-w-xs md:max-w-sm animate-slide-in" data-id="element-239">
        <div className="flex-shrink-0 mr-4" data-id="element-240">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8trgeA7VZR5XjJR2ciDSJW/Generated_Image_September_26%2C_2025_-_6_11PM.png" alt="Unshakable Conviction Book Cover" className="w-12 h-auto rounded-md" data-id="element-241" />
        </div>
        <div className="flex-1" data-id="element-242">
          <div data-id="element-243">
            <p className="font-medium text-gray-800 text-sm" data-id="element-244">
              {currentPurchase.name} <span className="text-gray-500" data-id="element-245">•</span>{' '}
              {currentPurchase.location}
            </p>
            <p className="text-gray-600 text-xs" data-id="element-246">
              Purchase made: {currentPurchase.price}
            </p>
            <p className="text-gray-700 font-medium text-sm" data-id="element-247">
              Unshakable Conviction
            </p>
            <span className="text-gray-500 text-xs mt-1 inline-block" data-id="element-248">
              {currentPurchase.time}
            </span>
          </div>
        </div>
      </div>
    </div>;
}